// extracted by mini-css-extract-plugin
export default {"form":"Form_form__JTPuH","section":"Form_section__mAYeX","wrapper":"Form_wrapper__Zasqe","group":"Form_group__+Ftpn"};